import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import campaignApi from "../api/campaignApi";
import { PERFORMANCE_QUERY_KEYS } from "../constants/performanceConstants";

const useCampaignOptions = () => {
  const campaignsQuery = useQuery({
    queryKey: [PERFORMANCE_QUERY_KEYS.campaigns, "selector"],
    queryFn: () => campaignApi.listCampaigns({ page: 1, limit: 100 }),
  });

  const campaigns = useMemo(() => {
    const rows = campaignsQuery.data?.data;
    return Array.isArray(rows) ? rows : [];
  }, [campaignsQuery.data]);

  const campaignOptions = useMemo(
    () =>
      campaigns.map((campaign) => ({
        value: campaign._id,
        label: campaign.code
          ? `${campaign.name} (${campaign.code})`
          : campaign.name,
      })),
    [campaigns],
  );

  return {
    campaignOptions,
    isLoading: campaignsQuery.isLoading,
  };
};

export default useCampaignOptions;
